<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    import List, {Group, Item, Graphic, Meta, Label, Separator, Subheader, Text, PrimaryText, SecondaryText} from '@smui/list';
    import Checkbox from '@smui/checkbox';

    import SettingsButton from "../buttons/SettingsButton.svelte";
    import DeleteButton from "../buttons/DeleteButton.svelte";
    import EditProjectFieldDialog from "../dialogs/EditProjectFieldDialog.svelte";
    import Overlay from "../Overlay.svelte";

    export let model;
    export let selection;
    export let editable = false;

    let showEditDialog = false;

    const closeDialogs = () => showEditDialog = false;

    function handleDelete() {
        if (confirm("Are you sure you want to delete this field definition?")) {
            dispatch("delete", model);
        }
    }

    function handleUpdate(evt) {
        dispatch("update", {
            old: model,
            new: evt.detail
        });
        model = evt.detail;
        closeDialogs();
    }
</script>

<Item class="project-field-summary" data-field-id={model.id}>
    <Text>
        <PrimaryText>{model.name}</PrimaryText>
        <SecondaryText>{model.description}</SecondaryText>
        <SecondaryText>{model.conditionDescription}</SecondaryText>
    </Text>

    <Meta style="position: absolute; right: 0; width: 30px; top: 25%;">
        <Checkbox bind:group={selection} value={model.id} />
        <SettingsButton onlyIcon on:click={() => showEditDialog = true}/>
        {#if editable}
            <DeleteButton onlyIcon on:click={handleDelete}/>
        {/if}
    </Meta>
</Item>

{#if showEditDialog}
    <Overlay show={showEditDialog} closable={true} background="darken" loaderBackground={false} on:close={closeDialogs}>
        <EditProjectFieldDialog
                {model}
                show={showEditDialog}
                {editable}
                on:close={closeDialogs}
                on:update={handleUpdate}
        />
    </Overlay>
{/if}

<style>
    :global(.project-field-summary[aria-checked="false"]) {
        border: 2px transparent #2CD533;
    }

    :global(.project-field-summary[aria-checked="true"]) {
        border: 2px solid #2CD533;
    }

    :global(.project-field-summary .mdc-checkbox) {
        display: none;
    }
</style>